<template>

    <div class="w1200 audition-page">

        <div class="audition-lottery audition-lottery-top">
            <div class="lottery-tabs">
                <span
                    v-for="item in lotteryOptions"
                    :key="item.dictValue"
                    :class="{ active: lotteryActive === item.dictValue }"
                    @click="toggleLottery(item.dictValue)">{{ item.dictLabel }}</span>
            </div>
            <span class="intro-trigger" @click="introVisible = true">活动介绍</span>
        </div>

        <div v-if="period && period.bannerImage" class="audition-banner">

            <el-image :src="bannerUrl" fit="cover" style="width:100%;height:280px;" />

        </div>

        <div class="audition-guide">
            <div class="guide-grid">
                <a
                    v-for="item in guideLinks"
                    :key="item.title"
                    href="javascript:;"
                    class="guide-item"
                    @click.prevent="openGuideLink(item)">
                    <i v-if="item.icon" :class="item.icon"></i>
                    <span>{{ item.title }}</span>
                </a>
            </div>
            <p v-if="!period" class="guide-empty">该彩种暂无海选活动</p>
        </div>



        <period-summary :period="period" :lottery-options="lotteryOptions" show-empty />



        <el-dialog title="活动介绍" :visible.sync="introVisible" width="640px" append-to-body>
            <ul class="intro-list">
                <li>仅支持双色球与大乐透前区（红球），面向认证用户征集万元级实战投注单（约 9,500～10,500 元）。</li>
                <li>开奖后按红球/前区命中个数计算本期积分：双色球 6 个=二等奖金额、5 个=200、4 个=10、3 个=5；大乐透前区 5 个=二等奖金额、4 个=200、3 个=10、2 个=5。</li>
                <li>排名依据往期累计，积分越高越靠前；多组红表/前区条件取最大命中数。</li>
                <li>认证缩水师/技巧师或满足条件的用户可提交方案，审核通过后参与当期排行。</li>
            </ul>
        </el-dialog>



        <div class="audition-toolbar">

            <div class="toolbar-right">

                <el-select v-model="sort" size="small" style="width:130px">

                    <el-option label="往期累计" value="score" />

                    <el-option label="本期积分" value="period" />

                    <el-option label="最新" value="latest" />

                    <el-option label="奖金预期" value="prize" />

                </el-select>

                <span class="apply_sss primary" :class="{ disabled: !periodOperable }" @click="goSubmit">提交方案</span>

                <span class="apply_sss" @click="goResult">查看结果</span>

            </div>

        </div>



        <entry-rank-list

            ref="rankList"

            :period-id="periodId"

            :period-name="periodName"

            :lottery-options="lotteryOptions"

            :lottery-active="lotteryActive"

            :sort="sort"

            @period-nav="handlePeriodNav" />



        <div class="audition-table" v-if="champions.length" style="margin-top:24px;">

            <div class="head">

                <div class="tit">冠王实战专题</div>

            </div>

            <el-table

                :data="champions"

                :border="true"

                style="width:100%"

                :header-cell-style="{ background: '#347CAF', color: '#fff' }">

                <el-table-column label="方案名称" prop="title">

                    <template slot-scope="{ row }">

                        <span>{{ row.title }}</span>

                    </template>

                </el-table-column>

                <el-table-column label="创作者" prop="userName" width="140" />

                <el-table-column label="往期累计" width="120">
                    <template slot-scope="{ row }">{{ formatScore(row.totalScore) }}</template>
                </el-table-column>

                <el-table-column label="荣誉" prop="badge" width="140" />

                <el-table-column label="操作" width="80" align="center">

                    <template slot-scope="{ row }">

                        <el-button type="text" size="small" class="title-link" @click.stop="goDetail(row)">详情</el-button>

                    </template>

                </el-table-column>

            </el-table>

        </div>

    </div>

</template>



<script>

import { getLatestPeriod, getAdjacentPeriod, getChampionTopic } from '@/api/audition'

import { queryLotteryType } from '@/api/common'

import PeriodSummary from './components/PeriodSummary.vue'

import EntryRankList from './components/EntryRankList.vue'

import { isPeriodOperable, ALLOWED_PRE_TYPES, filterAuditionLotteryOptions } from './utils'

export default {

    components: { PeriodSummary, EntryRankList },

    data () {

        return {

            period: null,

            periodId: null,

            periodName: '',

            champions: [],

            lotteryOptions: [],

            lotteryActive: '',

            sort: 'score',

            introVisible: false,

            guideLinks: [
                { title: '30秒搞懂我们要做什么？', icon: 'el-icon-reading', id: 55 },
                { title: '万元实战单选手可以卖缩水单', icon: '', id: 56 },
                { title: '海选万元实战单：角色', icon: '', id: 57 },
                { title: '公示晋级降级规则', icon: 'el-icon-chat-line-square', id: 58 },
                { title: '公示双色球彩票代表规则', icon: '', id: 59 },
                { title: '双色球/大乐透定价明细', icon: '', id: 60 },
                { title: '《万元实战单》栏目目标', icon: '', id: 61 },
                { title: '《万元实战单》项目背景', icon: '', id: 62 },
                { title: '缩水师技巧师提成规则？', icon: 'el-icon-user', id: 63 }
            ]

        }

    },

    computed: {

        bannerUrl () {

            if (!this.period || !this.period.bannerImage) return ''

            const img = this.period.bannerImage

            if (img.startsWith('http')) return img

            return process.env.VUE_APP_BASE_API + '/stage-api' + img

        },

        loggedIn () {

            return !!this.vuex_token

        },

        periodOperable () {

            return isPeriodOperable(this.period)

        }

    },

    mounted () {

        this.initFromRoute()

        this.loadLotteryTypes().then(() => {

            this.loadData()

        })

    },

    methods: {

        initFromRoute () {

            const q = this.$route.query

            if (q.sort) this.sort = q.sort

            if (q.preType) this.lotteryActive = q.preType

        },

        formatScore (val) {

            if (val == null || val === '') return '-'

            return Number(val).toLocaleString()

        },

        loadLotteryTypes () {

            return queryLotteryType().then(res => {

                if (res && res.code === 200) {

                    this.lotteryOptions = filterAuditionLotteryOptions(res.data)

                    if (!this.lotteryActive && this.lotteryOptions.length) {

                        this.lotteryActive = this.lotteryOptions[0].dictValue

                    } else if (this.lotteryActive && !ALLOWED_PRE_TYPES.includes(this.lotteryActive)) {

                        this.lotteryActive = this.lotteryOptions.length ? this.lotteryOptions[0].dictValue : ''

                    }

                }

            }).catch(() => {})

        },

        loadData () {

            this.loadPeriod()

            getChampionTopic(10).then(res => {

                if (res && res.code === 200) {

                    this.champions = res.data || []

                }

            }).catch(() => {})

        },

        applyPeriod (data) {

            if (data) {

                this.period = data

                this.periodId = data.id

                this.periodName = data.periodName

            } else {

                this.period = null

                this.periodId = null

                this.periodName = ''

            }

        },

        loadPeriod () {

            if (!this.lotteryActive) return

            getLatestPeriod(this.lotteryActive).then(res => {

                if (res && res.code === 200 && res.data) {

                    this.applyPeriod(res.data)

                } else {

                    this.applyPeriod(null)

                }

            }).catch(() => {})

        },

        handlePeriodNav (index) {

            if (!this.lotteryActive) return

            if (index === 0) {

                this.loadPeriod()

                return

            }

            if (!this.periodId) {

                this.$message.warning('暂无期次')

                return

            }

            const direction = index === 1 ? 'prev' : 'next'

            getAdjacentPeriod({

                preType: this.lotteryActive,

                periodId: this.periodId,

                direction

            }).then(res => {

                if (res && res.code === 200 && res.data) {

                    this.applyPeriod(res.data)

                } else if (index === 1) {

                    this.$message.warning('没有上一期了')

                } else {

                    this.$message.warning('已经是最新期')

                }

            }).catch(() => {})

        },

        toggleLottery (val) {

            if (this.lotteryActive === val) return

            this.lotteryActive = val

            this.$router.replace({

                path: this.$route.path,

                query: Object.assign({}, this.$route.query, { preType: val })

            }).catch(() => {})

            this.loadPeriod()

        },

        goSubmit () {

            if (!this.periodOperable) {

                this.$message.warning('本期已截止，无法提交')

                return

            }

            if (!this.vuex_token) {

                this.$router.push('/login?redirect=' + encodeURIComponent('/hxwysz/submit?preType=' + this.lotteryActive))

                return

            }

            this.$router.push({ path: '/hxwysz/submit', query: { preType: this.lotteryActive } })

        },

        goResult () {

            const query = this.period
                ? { periodId: this.period.id, preType: this.lotteryActive }
                : { preType: this.lotteryActive }

            this.$router.push({ path: '/hxwysz/result', query })

        },

        goDetail (row) {

            this.$router.push('/hxwysz/detail/' + row.id)

        },

        openGuideLink (item) {

            if (item && item.id) {

                this.$router.push({ path: '/article_details', query: { id: item.id, type: 'help' } })

                return

            }

            this.$alert('待接入', '提示', {

                type: 'warning',

                closeOnClickModal: true,

                confirmButtonText: '确定'

            }).catch(() => {})

        }

    }

}

</script>



<style lang="scss" scoped>

@import "./audition.scss";

</style>
